import { createApp } from 'vue';
import CompletedHikes from "./CompletedHikes.vue";

function mountCompletedHikesApp(elementId: string) {
  const el = document.getElementById(elementId)
  if (!el) return

  const app = createApp(CompletedHikes)
  app.mount(`#${elementId}`)
}

if (document.getElementById('completed-hikes-app')) {
  mountCompletedHikesApp('completed-hikes-app')
}
